import React from 'react';
import { Container, Tabs, Tab, Box, Grid, useMediaQuery } from '@mui/material';
import { CustomColors } from '../../theme';
import PersonIcon from '@mui/icons-material/Person';
import KeyIcon from '@mui/icons-material/Key';
import SecurityIcon from '@mui/icons-material/Security';
import Profile from './Profile';
import PasswordChange from './PasswordChange';
import Setup2FA from './Setup2FA';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <>{children}</>
        </Box>
      )}
    </div>
  );
}

const Settings = () => {
  const [value, setValue] = React.useState(0);
  const isSmallScreen = useMediaQuery('(max-width: 700px)');

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Container maxWidth="xl">
      {isSmallScreen ? (
        <Box sx={{ bgcolor: 'background.paper' }} style={style.container}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            allowScrollButtonsMobile
            scrollButtons="auto"
            aria-label="scrollable prevent tabs example"
            sx={{
              marginTop: '0',
            }}
          >
            <Tab
              label="Profile"
              icon={<PersonIcon />}
              iconPosition="start"
              sx={style.tab}
            />
            <Tab
              label="Password Change"
              icon={<KeyIcon />}
              iconPosition="start"
              sx={style.tab}
            />
            <Tab
              label="Setup 2Fa"
              icon={<SecurityIcon />}
              iconPosition="start"
              sx={style.tab}
            />
          </Tabs>
          <TabPanel value={value} index={0}>
            <Profile />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <PasswordChange />
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Setup2FA />
          </TabPanel>
        </Box>
      ) : (
        <Box sx={{ bgcolor: 'background.paper' }} style={style.container}>
          <Grid container>
            <Grid item md={2.5} xs={12}>
              <Tabs
                value={value}
                onChange={handleChange}
                variant="scrollable"
                scrollButtons={false}
                orientation="vertical"
                aria-label="scrollable prevent tabs example"
                sx={{
                  width: '200px',

                  '& .MuiTab-labelIcon': {
                    flexDirection: 'row',
                    justifyContent: 'flex-start',
                    textAlign: 'left',
                  },
                }}
              >
                <Tab
                  label="Profile"
                  icon={<PersonIcon />}
                  iconPosition="start"
                  sx={style.tab}
                />
                <Tab
                  label="Password Change"
                  icon={<KeyIcon />}
                  iconPosition="start"
                  sx={style.tab}
                />
                {/* <Tab
                  label="Setup 2Fa"
                  icon={<SecurityIcon />}
                  iconPosition="start"
                  sx={style.tab}
                /> */}
              </Tabs>
            </Grid>
            <Grid item md={9.5} xs={12}>
              <TabPanel value={value} index={0}>
                <Profile />
              </TabPanel>
              <TabPanel value={value} index={1}>
                <PasswordChange />
              </TabPanel>
              {/* <TabPanel value={value} index={2}>
                <Setup2FA />
              </TabPanel> */}
            </Grid>
          </Grid>
        </Box>
      )}
    </Container>
  );
};

export default Settings;

const style = {
  container: {
    backgroundColor: CustomColors.white,
    padding: '40px',
    marginTop: '40px',
  },
  tab: {},
};
